import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { shareReplay } from 'rxjs';
import { endpoints } from '../../utils/endpoints';
import {
    CodeVerifyTwoFactorAuthRequest,
    DisableTwoFactorAuthRequest,
    EnableTwoFactorAuthRequest,
    NotificationSettingsRequest,
    SaveUserSocialAccountsRequest,
} from '../models/api/requests/profileSettings.request';
import {
    NotificationSettingsResponse,
    TwoFactorAuthSecret,
    TwoFactorAuthSettings,
} from '../models/api/responses/profileSettings.response';
import { SocialAccount } from '../models/profile.interface';

@Injectable({
    providedIn: 'root',
})
export class ProfileSettingsService {
    private http = inject(HttpClient);


    //Two-factor Authentication methods
    fetchTwoFactorAuthSettings() {
        return this.http
            .get<TwoFactorAuthSettings>(
                endpoints.identity.children.getTwoFactorAuthSettings()
            )
            .pipe(shareReplay());
    }

    enableTwoFactorAuth(request: EnableTwoFactorAuthRequest) {
        return this.http.post<TwoFactorAuthSecret>(
            endpoints.identity.children.enableTwoFactorAuth(),
            request
        );
    }

    disableTwoFactorAuth(request: DisableTwoFactorAuthRequest) {
        return this.http.post<TwoFactorAuthSecret>(
            endpoints.identity.children.disableTwoFactorAuth(),
            request
        );
    }

    verifyTwoFactorAuth(request: CodeVerifyTwoFactorAuthRequest) {
        return this.http.post<void>(
            endpoints.identity.children.verifyTwoFactorAuth(),
            request
        );
    }

    saveNotificationSettings({
        receiveEmailNotifications,
        receiveNewsAndRecommendations,
    }: NotificationSettingsRequest) {
        return this.http.post<void>(
            endpoints.userProfile.children.saveNotificationSettings(),
            {
                receiveEmailNotifications,
                receiveNewsAndRecommendations,
            }
        );
    }

    getUserNotificationSettings(id: string) {
        return this.http
            .get<NotificationSettingsResponse>(
                endpoints.userProfile.children.getUserNotificationSettings(id)
            )
            .pipe(shareReplay());
    }

    saveUserSocialAccounts(request: SaveUserSocialAccountsRequest) {
        return this.http.post<void>(
            endpoints.userProfile.children.saveUserSocialAccounts(
                request.playerId
            ),
            request.accounts
        );
    }

    fetchSavedUserSocialAccounts(id: string) {
        return this.http
            .get<SocialAccount[]>(
                endpoints.userProfile.children.getSavedUserSocialAccounts(id)
            )
            .pipe(shareReplay());
    }

    fetchSupportedSocialAccounts() {
        return this.http
            .get<SocialAccount[]>(
                endpoints.socialNetworks.children.getSupportedSocialAccounts()
            )
            .pipe(shareReplay());
    }
}
